module.exports = __webpack_public_path__ + "img/asset_JSOL.cc74b5c4.svg";